import React, { useState } from "react";
import { WelcomeOverlay } from "@/components/WelcomeOverlay";
import { OnboardingTour } from "@/components/OnboardingTour/OnboardingTour";
import { LocationDetailsStep } from "@/components/OnboardingTour/LocationDetailsStep";

export interface OnboardingFlowProps {
  userRole: string | null;
  onComplete: () => void;
}

type OnboardingPhase = "welcome" | "tour" | "location";

/**
 * Orchestrates the full first-login onboarding experience:
 * welcome screen -> feature tour -> location confirmation -> onComplete.
 */
export const OnboardingFlow: React.FC<OnboardingFlowProps> = ({
  userRole,
  onComplete,
}) => {
  const [phase, setPhase] = useState<OnboardingPhase>("welcome");
  const normalizedRole = userRole?.trim().toUpperCase().replace(/[\s-]/g, "_");
  const canUpdateLocation =
    normalizedRole === "OWNER" || normalizedRole === "ADMIN";
  const completeTour = () => {
    if (canUpdateLocation) {
      setPhase("location");
      return;
    }
    onComplete();
  };

  if (phase === "welcome") {
    return <WelcomeOverlay onGetStarted={() => setPhase("tour")} />;
  }

  if (phase === "tour") {
    return (
      <OnboardingTour
        onBack={() => setPhase("welcome")}
        completesOnLastStep={!canUpdateLocation}
        onFinish={completeTour}
        onSkip={completeTour}
      />
    );
  }

  return (
    <LocationDetailsStep
      onBack={() => setPhase("tour")}
      onFinish={onComplete}
    />
  );
};

export default OnboardingFlow;
